export default {
  routerList: [

    {
      path: '/homePage',
      component: () => import('@/views/index/home/homePage.vue'),
      name: '主页',
      children: []
    },
    {
      path: '/product',
      component: () => import('@/views/index/home/product.vue'),
      name: '产品',
      children: []
    },
    {
      path: '/news',
      component: () => import('@/views/index/home/news.vue'),
      name: '新闻动态',
      children: []
    },
    {
      path: '/successCase',
      component: () => import('@/views/index/home/successCase.vue'),
      name: '成功案例',
      children: []
    },
    {
      path: '/trial',
      component: () => import('@/views/index/home/trial.vue'),
      name: '申请试用',
      children: []
    },
    {
      path: '/aboutUs',
      component: () => import('@/views/index/home/aboutUs.vue'),
      name: '关于锦旗',
      children: []
    },
    {
      path: '/contactUs',
      component: () => import('@/views/index/home/contactUs.vue'),
      name: '联系我们',
      children: []
    },
    {
      path: '/newList',
      component: () => import('@/views/index/home/newList.vue'),
      name: '新闻列表',
      children: []
    },
    {
      path: '/newDetails',
      component: () => import('@/views/index/home/newDetails.vue'),
      name: '新闻详情',
      children: []
    },
    {
      path: '/serviceSupport',
      component: () => import('@/views/index/home/serviceSupport.vue'),
      name: '服务于支持',
      children: []
    },
    {
      path: '/cooperativePartner',
      component: () => import('@/views/index/home/cooperativePartner.vue'),
      name: '合作伙伴',
      children: []
    },
  ]
}
